module.exports = __webpack_public_path__ + "static/media/pg17.9c356a2e.jpg";